// 語系常數
export const LANGS = {
  ZH_TW: 'zh-TW',
  EN_US: 'en',
};
